var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraAndMicIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0ffe2;}.b{fill:none;}.c{fill:#16871c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-395 -596)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 52,
    height: 52,
    rx: 10,
    transform: "translate(395 596)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.697 612.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H20.105V20.105H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.728,9.77V6.838A.84.84,0,0,0,13.89,6H3.838A.84.84,0,0,0,3,6.838v8.377a.84.84,0,0,0,.838.838H13.89a.84.84,0,0,0,.838-.838V12.283l3.351,3.351V6.419Z",
    transform: "translate(-0.487 -0.974)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.198 611.823)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H20.105V20.105H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.425,11.3a2.315,2.315,0,0,0,2.317-2.325l.008-4.65a2.325,2.325,0,1,0-4.65,0v4.65A2.322,2.322,0,0,0,10.425,11.3Zm4.107-2.325a4.021,4.021,0,0,1-4.107,3.952A4.021,4.021,0,0,1,6.317,8.974H5a5.412,5.412,0,0,0,4.65,5.208v2.542H11.2V14.182a5.4,5.4,0,0,0,4.65-5.208Z",
    transform: "translate(-0.372 0.272)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraAndMicIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cameraAndMicIcon.9baa152b74cf1f8d94967672e0910c91.svg";